import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCreditToBeApplied } from 'products/nomad_insurance/state/credit';
import { FEATURE_CREDITS } from 'consts';

const useCreditToBeApplied = () => {
  const dispatch = useDispatch();
  const { creditToBeApplied } = useSelector((state) => state.nomadInsurance.credit);
  // NI C2C and NI Reactivation gift cards are shown differently than other credits
  const hasCreditsToBeApplied = Boolean(
    creditToBeApplied &&
      creditToBeApplied?.campaignIdentifier !== 'ni_c2c' &&
      creditToBeApplied?.campaignIdentifier !== 'ni_reactivation_gift_card'
  );

  useEffect(() => {
    if (FEATURE_CREDITS) {
      dispatch(fetchCreditToBeApplied());
    }
  }, [dispatch]);

  return {
    creditToBeApplied: hasCreditsToBeApplied ? creditToBeApplied : null
  };
};

export default useCreditToBeApplied;
